export default __webpack_public_path__ + "static/media/ico_property_white.c441e70f.svg";